// extracted by mini-css-extract-plugin
module.exports = {"box":"PageBox_box__PqPzW","back":"PageBox_back__2dgn-","left":"PageBox_left__YbGBZ"};